import { useCallback, useState } from 'react';
import { IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { useSelectedSection, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIRSignOffDeleteDTO, WIRSignOffDTO } from 'types/wellGuardian';

import { useSectionUpdate } from './useSectionUpdate';

export const useResponsibleAndSignOffData = (intl: IntlShape) => {
  const [approvingUser, setApprovingUser] = useState<WIRSignOffDTO | null>(null);
  const [deletingUser, setDeletingUser] = useState<WIRSignOffDeleteDTO | null>(null);
  const [confirmApprovalModalOpen, setConfirmApprovalModalOpen] = useState<boolean>(false);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState<boolean>(false);
  const [deleteCheck, setDeleteCheck] = useState<boolean>(false);
  const [approveLoading, setApproveLoading] = useState<boolean>(false);

  const wir = useSelectedWIR();
  const bothSections = useSelectedSection();
  const { processSaveResponse } = useSectionUpdate(bothSections, intl);

  const confirmApprovalOkMethod = useCallback(async () => {
    if (wir?.wirNumber && approvingUser) {
      setApproveLoading(true);
      const wirResponse = await wellGuardianApiClient.addSignOff(wir?.wirNumber, approvingUser);
      if (wirResponse?.wirNumber) {
        await processSaveResponse(wirResponse);
      } else {
        toast.error(
          intl.formatMessage({
            id: 'wellGuardian.wir.wirCreation.wirUpdateError',
          }),
          {
            hideProgressBar: false,
            theme: 'colored',
          },
        );
      }
      setApprovingUser(null);
      setConfirmApprovalModalOpen(false);
      setApproveLoading(false);
    }
  }, [approvingUser, wir, intl, processSaveResponse]);

  const confirmApprovalDeleteMethod = useCallback(async () => {
    {/* istanbul ignore next */}
    if (deleteCheck) {
      {/* istanbul ignore next */}
      if (wir?.wirNumber && approvingUser) {
        setApproveLoading(true);
        const wirResponse = await wellGuardianApiClient.addSignOff(wir?.wirNumber, approvingUser);
        /* istanbul ignore next */
        if (wirResponse?.wirNumber) {
          await processSaveResponse(wirResponse);
        /* istanbul ignore next */
        } else {
          toast.error(
            intl.formatMessage({
              id: 'wellGuardian.wir.wirCreation.wirUpdateError',
            }),
            {
              hideProgressBar: false,
              theme: 'colored',
            },
          );
        }
        setApprovingUser(null);
        setConfirmDeleteModalOpen(false);
        setApproveLoading(false);
        setDeleteCheck(false);
      }
    } else {
      if (wir?.wirNumber && deletingUser && deletingUser.signOffType) {
        setApproveLoading(true);
        const wirResponse = await wellGuardianApiClient.deleteSignOff(
          wir?.wirNumber,
          deletingUser.signOffType,
        );
        if (wirResponse?.wirNumber) {
          await processSaveResponse(wirResponse);
          toast.success(
            intl.formatMessage({
              id: 'wellGuardian.wir.wirCreation.wirUpdateRevert',
            }),
            {
              hideProgressBar: false,
              theme: 'colored',
            },
          );
        } else {
          toast.error(
            intl.formatMessage({
              id: 'wellGuardian.wir.wirCreation.wirUpdateRevertError',
            }),
            {
              hideProgressBar: false,
              theme: 'colored',
            },
          );
        }
        setDeletingUser(null);
        setConfirmDeleteModalOpen(false);
        setApproveLoading(false);
        setDeleteCheck(false);
      }
    }
  }, [deleteCheck, wir?.wirNumber, approvingUser, processSaveResponse, intl, deletingUser]);
  return {
    confirmApprovalOkMethod,
    confirmApprovalDeleteMethod,
    setApprovingUser,
    setDeletingUser,
    confirmApprovalModalOpen,
    setConfirmApprovalModalOpen,
    confirmDeleteModalOpen,
    setConfirmDeleteModalOpen,
    deleteCheck,
    setDeleteCheck,
    approveLoading,
  };
};
